module.exports = __webpack_public_path__ + "img/accI.d0c5bb72.png";